export default __webpack_public_path__ + "static/media/sat-gray.cde69faf.png";